import { createContext } from 'react';
import {
	TLanguageIDs,
	IDataGetCustomerInfo,
	ICustomerLocalizationInfo,
	ICustomerStylesInfo,
	ILatestSoftwareUpdateInfo,
	IBpaShort,
} from 'types';

export type TCustomerFullInfoVisibleForm = 'mainForm' | 'localizationForm' | 'styleForm' | 'softwareForm' | 'bpaForm';
export type TSelectedLocalizationItem = { id: string | null; name: string | null };
export interface ISelectedStyleGroup {
	id: string;
	key: string;
}

export interface ICustomerFullInfoState {
	customerFullInfoVisibleForm: TCustomerFullInfoVisibleForm;
	customerForFullInfo: IDataGetCustomerInfo | null;
	selectedLocalizationGroup: TSelectedLocalizationItem | null;
	selectedLocalizationLanguage: TSelectedLocalizationItem | null;
	localizationData: ICustomerLocalizationInfo | null;
	styleData: null | ICustomerStylesInfo;
	selectedStyleGroup: null | ISelectedStyleGroup;
	selectedStyleLanguage: null | TLanguageIDs;
	latestSoftwareUpdateData: ILatestSoftwareUpdateInfo | null;
	bpaData: Nullable<IBpaShort[]>;
}

export const customerFullInfoInitialState: ICustomerFullInfoState = {
	customerFullInfoVisibleForm: 'mainForm',
	customerForFullInfo: null,
	selectedLocalizationLanguage: null,
	selectedLocalizationGroup: null,
	localizationData: null,
	styleData: null,
	selectedStyleGroup: null,
	selectedStyleLanguage: null,
	latestSoftwareUpdateData: null,
	bpaData: null,
};

export interface ICustomerFullInfoContext extends ICustomerFullInfoState {
	changeCustomerFullInfoVisibleForm(value: TCustomerFullInfoVisibleForm): void;
	setLocalizationGroup(value: TSelectedLocalizationItem | null): void;
	setLocalizationLanguage(value: TSelectedLocalizationItem | null): void;
	setLocalizationData(value: ICustomerLocalizationInfo | null): void;
	setStyleGroup(value: ISelectedStyleGroup): void;
	setStyleLanguage(value: TLanguageIDs): void;
	setLatestSoftwareUpdateData(value: ILatestSoftwareUpdateInfo | null): void;
}

export const CustomerFullInfoContext = createContext<ICustomerFullInfoContext>({
	changeCustomerFullInfoVisibleForm: () => undefined,
	setLocalizationGroup: () => undefined,
	setLocalizationLanguage: () => undefined,
	setLocalizationData: () => undefined,
	setStyleGroup: () => undefined,
	setStyleLanguage: () => undefined,
	setLatestSoftwareUpdateData: () => undefined,
	...customerFullInfoInitialState,
});
